function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ffdc6c}.st21{fill:none;stroke:#f8b26a;stroke-width:4.5884;stroke-linecap:round;stroke-miterlimit:10}");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.9912 0.1325 -0.1325 0.9912 19.5946 -16.4002) translate(133,138.9995) scale(0.6222222222222222)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.9912 0.1325 -0.1325 0.9912 19.5946 -16.4002) translate(133,138.9995) scale(0.6222222222222222)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.8102 -0.5862 0.5862 0.8102 10.3558 116.5189) translate(185.074,42.271) scale(0.3916444444444444)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.8102 -0.5862 0.5862 0.8102 10.3558 116.5189) translate(185.074,42.271) scale(0.3916444444444444)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.7153 0.6988 -0.6988 0.7153 199.1367 -101.9661) translate(224.712,193.41799999999998) scale(0.3647555555555556)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.7153 0.6988 -0.6988 0.7153 199.1367 -101.9661) translate(224.712,193.41799999999998) scale(0.3647555555555556)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.7812 0.6242 -0.6242 0.7812 76.8196 -5.7423) translate(46.602000000000004,106.7265) scale(0.3879111111111111)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.7812 0.6242 -0.6242 0.7812 76.8196 -5.7423) translate(46.602000000000004,106.7265) scale(0.3879111111111111)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.7381 -0.6747 0.6747 0.7381 -136.8065 106.8361) translate(69.2025,229.6265) scale(0.5011777777777778)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,-128)"
}, React.createElement("g", {
  transform: "matrix(0.7381 -0.6747 0.6747 0.7381 -136.8065 106.8361) translate(69.2025,229.6265) scale(0.5011777777777778)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,128)"
}, React.createElement("g", {
  transform: "matrix(0.9912 0.1325 -0.1325 0.9912 19.5946 -16.4002) translate(133,138.9995) scale(0.6222222222222222)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,128)"
}, React.createElement("g", {
  transform: "matrix(0.9912 0.1325 -0.1325 0.9912 19.5946 -16.4002) translate(133,138.9995) scale(0.6222222222222222)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,128)"
}, React.createElement("g", {
  transform: "matrix(0.8102 -0.5862 0.5862 0.8102 10.3558 116.5189) translate(185.074,42.271) scale(0.3916444444444444)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,128)"
}, React.createElement("g", {
  transform: "matrix(0.8102 -0.5862 0.5862 0.8102 10.3558 116.5189) translate(185.074,42.271) scale(0.3916444444444444)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref17 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,128)"
}, React.createElement("g", {
  transform: "matrix(0.7153 0.6988 -0.6988 0.7153 199.1367 -101.9661) translate(224.712,193.41799999999998) scale(0.3647555555555556)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref18 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,128)"
}, React.createElement("g", {
  transform: "matrix(0.7153 0.6988 -0.6988 0.7153 199.1367 -101.9661) translate(224.712,193.41799999999998) scale(0.3647555555555556)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref19 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,128)"
}, React.createElement("g", {
  transform: "matrix(0.7812 0.6242 -0.6242 0.7812 76.8196 -5.7423) translate(46.602000000000004,106.7265) scale(0.3879111111111111)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,128)"
}, React.createElement("g", {
  transform: "matrix(0.7812 0.6242 -0.6242 0.7812 76.8196 -5.7423) translate(46.602000000000004,106.7265) scale(0.3879111111111111)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref21 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-128,128)"
}, React.createElement("g", {
  transform: "matrix(0.7381 -0.6747 0.6747 0.7381 -136.8065 106.8361) translate(69.2025,229.6265) scale(0.5011777777777778)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref22 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128,128)"
}, React.createElement("g", {
  transform: "matrix(0.7381 -0.6747 0.6747 0.7381 -136.8065 106.8361) translate(69.2025,229.6265) scale(0.5011777777777778)"
}, React.createElement("g", {
  "data-icon": "",
  transform: "scale(0.9)"
}, React.createElement("use", {
  xlinkHref: "#id-0.5540554203892811",
  x: -50,
  y: -50
}))));

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%",
  fill: "url(#pid-0.9073342969111184)"
});

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "#eeeeee",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    width: "100%",
    height: "100%",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1084 322",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("defs", null, React.createElement("pattern", {
    id: "pid-0.9073342969111184",
    x: 0,
    y: 0,
    width: 76.80000000000001,
    height: 76.80000000000001,
    patternUnits: "userSpaceOnUse"
  }, React.createElement("g", {
    transform: "scale(0.30000000000000004)"
  }, React.createElement("defs", null, React.createElement("g", {
    id: "id-0.5540554203892811"
  }, _ref2, React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 21.4,
    "data-fill": "c1",
    style: {
      fill: "rgb(255, 220, 108)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 50,
    y1: 10,
    x2: 50,
    y2: 21.8,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 30,
    y1: 15.4,
    x2: 35.9,
    y2: 25.6,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 15.4,
    y1: 30,
    x2: 25.6,
    y2: 35.9,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 10,
    y1: 50,
    x2: 21.8,
    y2: 50,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 15.4,
    y1: 70,
    x2: 25.6,
    y2: 64.1,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 30,
    y1: 84.6,
    x2: 35.9,
    y2: 74.4,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 50,
    y1: 90,
    x2: 50,
    y2: 78.2,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 70,
    y1: 84.6,
    x2: 64.1,
    y2: 74.4,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 84.6,
    y1: 70,
    x2: 74.4,
    y2: 64.1,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 90,
    y1: 50,
    x2: 78.2,
    y2: 50,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 84.6,
    y1: 30,
    x2: 74.4,
    y2: 35.9,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }), React.createElement("line", {
    className: "st21",
    x1: 70,
    y1: 15.4,
    x2: 64.1,
    y2: 25.6,
    "data-stroke": "c2",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    "data-idx": 0,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "-58.5047px 39.4938px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -96.2592 93.9447)",
    fill: "#B3B4B4",
    cx: 69.5,
    cy: 167.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 0,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "197.495px 39.4938px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -96.2592 93.9447)",
    fill: "#B3B4B4",
    cx: 69.5,
    cy: 167.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 1,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "111.489px -55.5005px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 15.9378 184.9119)",
    fill: "#B3B4B4",
    cx: 239.5,
    cy: 72.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 1,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "367.489px -55.5005px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 15.9378 184.9119)",
    fill: "#B3B4B4",
    cx: 239.5,
    cy: 72.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 2,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "73.5px -2.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 194,
    y1: 125.5,
    x2: 209,
    y2: 125.5,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 201.5,
    y1: 133,
    x2: 201.5,
    y2: 118,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 2,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "329.5px -2.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 194,
    y1: 125.5,
    x2: 209,
    y2: 125.5,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 201.5,
    y1: 133,
    x2: 201.5,
    y2: 118,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 3,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "64px 116px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 186,
    y1: 244,
    x2: 198,
    y2: 244,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 192,
    y1: 250,
    x2: 192,
    y2: 238,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 3,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "320px 116px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 186,
    y1: 244,
    x2: 198,
    y2: 244,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 192,
    y1: 250,
    x2: 192,
    y2: 238,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 4,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "-107.5px -81.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 46.5,
    x2: 29,
    y2: 46.5,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 20.5,
    y1: 55,
    x2: 20.5,
    y2: 38,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 4,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "148.5px -81.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 46.5,
    x2: 29,
    y2: 46.5,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 20.5,
    y1: 55,
    x2: 20.5,
    y2: 38,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 5,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "9.52531px -55.8316px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.4903 -0.8715 0.8715 0.4903 7.2038 156.6452)",
    fill: "#B3B4B4",
    cx: 137.531,
    cy: 72.163,
    rx: 6.525,
    ry: 6.525,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 5,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "265.525px -55.8316px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.4903 -0.8715 0.8715 0.4903 7.2038 156.6452)",
    fill: "#B3B4B4",
    cx: 137.531,
    cy: 72.163,
    rx: 6.525,
    ry: 6.525,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 6,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "15.4918px 88.4925px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -109.6566 158.3945)",
    fill: "#B3B4B4",
    cx: 143.5,
    cy: 216.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 6,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "271.492px 88.4925px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -109.6566 158.3945)",
    fill: "#B3B4B4",
    cx: 143.5,
    cy: 216.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 7,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "-37.0041px -92.0005px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 0.2332 72.5839)",
    fill: "#B3B4B4",
    cx: 91,
    cy: 36,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 7,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "218.996px -92.0005px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 0.2332 72.5839)",
    fill: "#B3B4B4",
    cx: 91,
    cy: 36,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 8,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "120.988px 20.9965px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -34.1432 212.4976)",
    fill: "#B3B4B4",
    cx: 249,
    cy: 149,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 8,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "376.988px 20.9965px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -34.1432 212.4976)",
    fill: "#B3B4B4",
    cx: 249,
    cy: 149,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 9,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "-121.003px 111.99px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -163.3891 70.8358)",
    fill: "#B3B4B4",
    cx: 7,
    cy: 240,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 9,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "134.997px 111.99px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,-128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -163.3891 70.8358)",
    fill: "#B3B4B4",
    cx: 7,
    cy: 240,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 10,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "5.00676px 10.9986px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref3), React.createElement("g", {
    "data-idx": 10,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "261.007px 10.9986px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref4), React.createElement("g", {
    "data-idx": 11,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "57.082px -85.7235px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref5), React.createElement("g", {
    "data-idx": 11,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "313.082px -85.7235px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref6), React.createElement("g", {
    "data-idx": 12,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "96.7127px 65.4146px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref7), React.createElement("g", {
    "data-idx": 12,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "352.713px 65.4146px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref8), React.createElement("g", {
    "data-idx": 13,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "-81.3936px -21.2786px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref9), React.createElement("g", {
    "data-idx": 13,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "174.606px -21.2786px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref10), React.createElement("g", {
    "data-idx": 14,
    "data-dup": "",
    dx: -128,
    dy: -128,
    style: {
      transformOrigin: "-58.7991px 101.632px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref11), React.createElement("g", {
    "data-idx": 14,
    "data-dup": "",
    dx: 128,
    dy: -128,
    style: {
      transformOrigin: "197.201px 101.632px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref12), React.createElement("g", {
    "data-idx": 0,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "-58.5047px 295.494px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -96.2592 93.9447)",
    fill: "#B3B4B4",
    cx: 69.5,
    cy: 167.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 0,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "197.495px 295.494px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -96.2592 93.9447)",
    fill: "#B3B4B4",
    cx: 69.5,
    cy: 167.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 1,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "111.489px 200.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 15.9378 184.9119)",
    fill: "#B3B4B4",
    cx: 239.5,
    cy: 72.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 1,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "367.489px 200.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 15.9378 184.9119)",
    fill: "#B3B4B4",
    cx: 239.5,
    cy: 72.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 2,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "73.5px 253.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 194,
    y1: 125.5,
    x2: 209,
    y2: 125.5,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 201.5,
    y1: 133,
    x2: 201.5,
    y2: 118,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 2,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "329.5px 253.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 194,
    y1: 125.5,
    x2: 209,
    y2: 125.5,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 201.5,
    y1: 133,
    x2: 201.5,
    y2: 118,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 3,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "64px 372px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 186,
    y1: 244,
    x2: 198,
    y2: 244,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 192,
    y1: 250,
    x2: 192,
    y2: 238,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 3,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "320px 372px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 186,
    y1: 244,
    x2: 198,
    y2: 244,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 192,
    y1: 250,
    x2: 192,
    y2: 238,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 4,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "-107.5px 174.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 46.5,
    x2: 29,
    y2: 46.5,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 20.5,
    y1: 55,
    x2: 20.5,
    y2: 38,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 4,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "148.5px 174.5px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("g", null, React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 46.5,
    x2: 29,
    y2: 46.5,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  }), React.createElement("line", {
    fill: "none",
    stroke: "#B3B4B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 20.5,
    y1: 55,
    x2: 20.5,
    y2: 38,
    "data-stroke": "c4",
    style: {
      stroke: "rgb(179, 180, 181)"
    }
  })))), React.createElement("g", {
    "data-idx": 5,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "9.52531px 200.168px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.4903 -0.8715 0.8715 0.4903 7.2038 156.6452)",
    fill: "#B3B4B4",
    cx: 137.531,
    cy: 72.163,
    rx: 6.525,
    ry: 6.525,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 5,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "265.525px 200.168px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.4903 -0.8715 0.8715 0.4903 7.2038 156.6452)",
    fill: "#B3B4B4",
    cx: 137.531,
    cy: 72.163,
    rx: 6.525,
    ry: 6.525,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 6,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "15.4918px 344.493px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -109.6566 158.3945)",
    fill: "#B3B4B4",
    cx: 143.5,
    cy: 216.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 6,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "271.492px 344.493px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -109.6566 158.3945)",
    fill: "#B3B4B4",
    cx: 143.5,
    cy: 216.5,
    rx: 5.5,
    ry: 5.5,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 7,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "-37.0041px 163.999px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 0.2332 72.5839)",
    fill: "#B3B4B4",
    cx: 91,
    cy: 36,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 7,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "218.996px 163.999px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 0.2332 72.5839)",
    fill: "#B3B4B4",
    cx: 91,
    cy: 36,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 8,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "120.988px 276.996px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -34.1432 212.4976)",
    fill: "#B3B4B4",
    cx: 249,
    cy: 149,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 8,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "376.988px 276.996px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -34.1432 212.4976)",
    fill: "#B3B4B4",
    cx: 249,
    cy: 149,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 9,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "-121.003px 367.99px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(-128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -163.3891 70.8358)",
    fill: "#B3B4B4",
    cx: 7,
    cy: 240,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 9,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "134.997px 367.99px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, React.createElement("g", {
    transform: "translate(128,128)"
  }, React.createElement("ellipse", {
    transform: "matrix(0.7249 -0.6888 0.6888 0.7249 -163.3891 70.8358)",
    fill: "#B3B4B4",
    cx: 7,
    cy: 240,
    rx: 4,
    ry: 4,
    "data-fill": "c3",
    style: {
      fill: "rgb(179, 180, 180)"
    }
  }))), React.createElement("g", {
    "data-idx": 10,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "5.00676px 266.999px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref13), React.createElement("g", {
    "data-idx": 10,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "261.007px 266.999px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref14), React.createElement("g", {
    "data-idx": 11,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "57.082px 170.276px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref15), React.createElement("g", {
    "data-idx": 11,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "313.082px 170.276px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref16), React.createElement("g", {
    "data-idx": 12,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "96.7127px 321.415px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref17), React.createElement("g", {
    "data-idx": 12,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "352.713px 321.415px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref18), React.createElement("g", {
    "data-idx": 13,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "-81.3936px 234.721px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref19), React.createElement("g", {
    "data-idx": 13,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "174.606px 234.721px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref20), React.createElement("g", {
    "data-idx": 14,
    "data-dup": "",
    dx: -128,
    dy: 128,
    style: {
      transformOrigin: "-58.7991px 357.633px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref21), React.createElement("g", {
    "data-idx": 14,
    "data-dup": "",
    dx: 128,
    dy: 128,
    style: {
      transformOrigin: "197.201px 357.633px",
      animation: "1s linear 0s infinite normal forwards running beat"
    }
  }, _ref22)))), _ref23);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun.b77ffd24.svg";
export { ForwardRef as ReactComponent };